/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const Church = (props) => {
    const { className } = props;
    return (
        <SvgIcon className={className} viewBox="0 0 51 53" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37.0117 24.4623L28.05 19.085V12.24H33.915C34.6194 12.24 35.19 11.6694 35.19 10.965V8.415C35.19 7.71056 34.6194 7.14 33.915 7.14H28.05V1.275C28.05 0.570562 27.4794 0 26.775 0H24.225C23.5206 0 22.95 0.570562 22.95 1.275V7.14H17.085C16.3806 7.14 15.81 7.71056 15.81 8.415V10.965C15.81 11.6694 16.3806 12.24 17.085 12.24H22.95V19.085L13.9883 24.4623C13.2201 24.923 12.75 25.7531 12.75 26.6489V52.847H20.4V37.955C20.4 35.138 22.683 32.855 25.5 32.855C28.317 32.855 30.6 35.138 30.6 37.955V52.847H38.25V26.6489C38.25 25.7532 37.7798 24.9229 37.0117 24.4623ZM0 36.3582V51.5722C0 52.2766 0.570562 52.8472 1.275 52.8472H10.2V30.3052L1.54514 34.0138C0.607832 34.4162 0.000206898 35.3382 0 36.3582ZM40.8 30.3052L49.4549 34.0138C50.392 34.4162 51 35.3382 51 36.3582V51.7252C51 52.4296 50.4294 53.0002 49.725 53.0002H40.8V30.3052Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

Church.defaultProps = { className: '' };

Church.propTypes = { className: PropTypes.string };

export default Church;
